export default "__VITE_ASSET__CTfR49KF__"